export default "__VITE_ASSET__Clh4m593__"